<div class="synergy-card">
  <mat-card class="supports-card" *ngIf="support">
    <mat-card-content>
      <!--begin::Content-->
      <div class="wallet_microcredit_wrapper s_archive_wrapper">
        <div class="microcredit s_archive row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-sm-12 s_archive-img-container">
                <div class="s_archive-img {{support.status}}">
                  <img src={{support.campaign.imageURL}} alt={{support.campaign.title}} />

                  <div class="s_archive-date" *ngIf="support.status=='completed'">
                    <span matTooltip="{{'SUPPORT.STATUS.COMPLETED_TOOLTIP' | translate}}">
                      {{'SUPPORT.STATUS.COMPLETED' | translate}}</span>
                  </div>
                  <div class="s_archive-date" *ngIf="support.status=='unpaid'">
                    <span matTooltip="{{'SUPPORT.STATUS.PENDING_TOOLTIP' | translate}}">
                      {{'SUPPORT.STATUS.PENDING' | translate}}</span>
                  </div>
                  <div class="s_archive-date" *ngIf="support.status=='paid'">
                    <span matTooltip="{{'SUPPORT.STATUS.CONFIRMED_TOOLTIP' | translate}}">
                      {{'SUPPORT.STATUS.CONFIRMED' | translate}}</span>
                  </div>

                </div>
              </div>
            </div>
            <div class=" s_archive-content container-fluid">
              <div class="s_archive-heading row">
                <h4 class="s_archive-title col-12">{{support.campaign.title}}</h4>

              </div>
              <!-- If redeemable show info -->
              <div class="s_archive-credit-info row" *ngIf="support.campaign.redeemable">
                <div class="s_archive-dates col-8">
                  <span class="tag">{{'CAMPAIGN.REDEEM_PERIOD' | translate}}</span><br>
                  <span class="dates">{{support.campaign.redeemStarts | date: 'd.M.y'}} - {{support.campaign.redeemEnds | date: 'd.M.y'}}</span><br>
                  <span class="desc">{{'CAMPAIGN.REDEEM_PERIOD_SUB' | translate}}</span>
                </div>
                <div class="s_archive-points col-4">
                  <div class="init-amount">
                    <span class="hypertitle">
                      {{'GENERAL.FROM' | translate}}
                    </span>
                    <span>
                      {{support.initialTokens | currency:'EUR'}}
                    </span>
                  </div>
                  <div class="current-amount">
                    <span class="hypertitle">
                      {{'SUPPORT.REMAINING' | translate}}
                    </span>
                    <span>{{ support.currentTokens | currency:'EUR'}}</span>
                  </div>
                </div>
              </div>
              <!-- If not redeemable show thank you -->
              <div class="s_archive-credit-info row" *ngIf="!support.campaign.redeemable">
                <div class="col-8">
                  {{ 'CAMPAIGN.NOT_REDEEMABLE.DESC' | translate }}
                </div>
                <div class="s_archive-points col-4">
                  <div class="current-amount">
                    <span class="hypertitle">
                      {{ 'CAMPAIGN.NOT_REDEEMABLE.DONATED' | translate }}
                    </span>
                    <span>
                      {{support.initialTokens | currency:'EUR'}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="s_archive-subtitle row">
                <div class="col-md-12">
                  <p [innerHTML]="support.campaign.terms"></p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 s_archive-info">
                  <div class="s_archive-partner" *ngIf="type!='single'">
                    <!-- If unpaid so payment info -->
                    <div class="payment-info" *ngIf="support.status=='unpaid'">
                      <h4>{{'CAMPAIGN.UNPAID_TITLE' | translate}}</h4>
                      <p>{{'CAMPAIGN.UNPAID_MSSG' | translate}}</p>
                      <div class="s_archive-merch-name">
                        <span class="mdi mdi-handshake"></span> {{'SUPPORT.ARRAY.PAYMENT_ID' | translate}}: {{support.payment._id}}
                        <br>
                      </div>

                      <div class="s_archive-merch-name" *ngIf="support.method!='store'">
                        <span class="mdi mdi-cash"></span> {{'SUPPORT.PAYMENT_METHOD' | translate}}: {{'SUPPORT.PAYMENT.BANK' | translate}}
                        <br>
                        <span class="mdi mdi-cash"></span> {{'SUPPORT.PAYMENT_DETAILS' | translate}}: {{support | support_payment}}
                      </div>
                      <div class="s_archive-merch-name" *ngIf="support.method=='store'">
                        <span class="mdi mdi-cash"></span> {{'SUPPORT.PAYMENT_METHOD' | translate}}: {{'SUPPORT.PAYMENT.STORE' | translate}}
                      </div>
                    </div>

                    <div class="s_archive-merch-name">
                      <span class="mdi mdi-shopping"></span> {{support.campaign.partner.name}}
                    </div>
                    <div class="s_archive-merch-adress" *ngIf="support.campaign.partner.address">
                      <span class="mdi mdi-pin"></span> {{support.campaign.partner.address.street}}, {{support.campaign.partner.address.city}}
                    </div>
                    <div class="s_archive-merch-phone">
                      <a href="tel:+{{support.campaign.partner.phone}}">
                        <span class="mdi mdi-phone"></span> {{support.campaign.partner.phone}}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--end::Content-->
    </mat-card-content>
  </mat-card>
</div>
